<div class="p-t p-b">
    @if (scriptStatus.busy) {
    <div class="p-a center">
        <div class="busy-state-animation"></div>
    </div>
    }

    <result [status]="scriptStatus"
            duration="permanent"></result>

    <div [ngClass]="{'visually-hidden' : scriptStatus.busy}"
         #klarnacontainer></div>
</div>